import { adminRoot } from "./config";
import { VscSettings } from "react-icons/vsc";
import { BiHome } from "react-icons/bi";
import { PiMotorcycle } from "react-icons/pi";
import { LuPackageOpen } from "react-icons/lu";
import { LuLayoutDashboard } from "react-icons/lu";
import { LiaUserLockSolid } from "react-icons/lia";
import { LuPackageSearch } from "react-icons/lu";
import { PiCubeDuotone } from "react-icons/pi";
import { HiOutlineInboxStack } from "react-icons/hi2";
import { PiMicrosoftExcelLogo } from "react-icons/pi";
import { FiUsers } from "react-icons/fi";
import { CiBoxList } from "react-icons/ci";
import { PiWarehouse } from "react-icons/pi";
import { TbBrandCitymapper } from "react-icons/tb";
import { PiUserSwitch } from "react-icons/pi";
import { GrMoney } from "react-icons/gr";
import { PiBasket } from "react-icons/pi";
import { PiPresentationChart } from "react-icons/pi";
import { TbFaceIdError } from "react-icons/tb";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BsStoplights } from "react-icons/bs";
import { PiRocketLaunch } from "react-icons/pi";
import { PiAirplaneTakeoffLight } from "react-icons/pi";
import { HiOutlineReceiptRefund } from "react-icons/hi2";
import { VscKey } from "react-icons/vsc";
import { LuPackageMinus } from "react-icons/lu";
import { TbTruckReturn } from "react-icons/tb";

import PublicView from "src/views/PublicView";
import ProtectedView from "src/views/ProtectedView";

import { Outlet } from "react-router-dom";

import Login from "src/views/user/Login";
import Denied from "src/views/user/Denied";
import Orders from "src/views/app/OrderManagement/Orders";
import Roles from "src/views/app/userRoles/Roles";
import Users from "src/views/app/user/Users";
import AddUser from "src/views/app/user/AddUser";
import UpdateExcel from "src/views/app/ProductManagement/UpdateExcel";
import Products from "src/views/app/ProductManagement/Products";
import SepidarSync from "src/views/app/WarehouseManagement/SepidarSync";
import EditUser from "src/views/app/user/EditUser";
import Invoices from "src/views/app/FinancialManagement/Invoices/index.js";
import AddOrder from "src/views/app/OrderManagement/AddOrder/AddOrder";
import ProductStatistics from "src/views/app/CommercialManagement/ProductStatistics/ProductStatistics";
import FinancialReport from "src/views/app/FinancialManagement/FinancialReport/FinancialReport";
import Logs from "src/views/app/Setting/Log/Logs";
import MainDashboard from "src/views/global/Dashboard";
import QueueInvoices from "src/views/app/FinancialManagement/QueueInvoices";
import Limitation from "src/views/app/Limitation/Limitation";
import FinancialSales from "src/views/app/FinancialManagement/FinancialSales";
import CommercialSales from "src/views/app/CommercialManagement/Sales";
import VoucherStatistics from "src/views/app/CommercialManagement/VoucherStatistics/VoucherStatistics";
import SalesVelocityStatistics from "src/views/app/SalesManagment/SalesVelocityStatistics/SalesVelocityStatistics";
import TehranOrders from "src/views/app/WarehouseManagement/TehranOrders";
import InstantOrders from "src/views/app/WarehouseManagement/InstantOrders";
import NonTehranOrders from "src/views/app/WarehouseManagement/NonTehranOrders";
import SellerProducts from "src/views/app/SellerManagement/SellerProducts";
import SellerOrders from "src/views/app/SellerManagement/SellerOrders";
import SellerInbound from "src/views/app/SellerManagement/SellerInbound";
import SellerSales from "src/views/app/SellerManagement/SellerSales";
import ChangePassword from "src/views/app/Setting/ChangePassword/ChangePassword";
import Inbounds from "src/views/app/WarehouseManagement/Inbounds";
import SellersSales from "src/views/app/FinancialManagement/SellersSales/SellersSales";
import ReturningCustomer from "src/views/app/SalesManagment/ReturningCustomer/ReturningCustomer";
import SubmitRefund from "src/views/app/SubmitRefund/SubmitRefund";
import Refunds from "src/views/app/WarehouseManagement/Refunds";
import SellerRefund from "src/views/app/SellerManagement/SellerRefund";
import Categories from "src/views/app/ProductManagement/Categories";
import Tags from "src/views/app/ProductManagement/Tags";
import Brands from "src/views/app/ProductManagement/Brands";
import Attributes from "src/views/app/ProductManagement/Attributes";
import Reviews from "src/views/app/ProductManagement/Reviews";
import AddNewProduct from "src/views/app/ProductManagement/AddNewProduct/AddNewProduct";
import Copouns from "src/views/app/ShopManagement/Coupons";
import ShopSettings from "src/views/app/ShopManagement/ShopSettings";

// routes create based on this array
const menuArray = [
    {
        path: "",
        element: <ProtectedView />,
        subs: [
            {
                path: "",
                element: <MainDashboard />,
            },
        ],
    },
    {
        icon: <LuLayoutDashboard size={30} />,
        label: "پیشخوان",
        path: `${adminRoot}/dashboard`,
        inMenu: true,
        element: <ProtectedView />,
        permission: "viewDashboard",
        subs: [
            {
                icon: <BiHome />,
                label: "صفحه اصلی",
                path: `${adminRoot}/dashboard`,
                element: <MainDashboard />,
                inMenu: true,
            },
        ],
    },
    {
        icon: <LuPackageOpen size={30} />,
        label: "مدیریت سفارشات",
        path: `${adminRoot}/order-management`,
        inMenu: true,
        element: <ProtectedView />,
        permission: "viewOrdersMenu",
        subs: [
            {
                icon: <CiBoxList />,
                label: "لیست سفارش‌ها",
                path: `${adminRoot}/order-management/orders`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <Orders />,
            },
            {
                icon: <CiBoxList />,
                label: "لیست سفارشات سلرها",
                path: `${adminRoot}/order-management/sellers/orders`,
                inMenu: true,
                permission: "financialViewSalesList",
                element: <SellersSales />,
            },
            {
                icon: <CiBoxList />,
                label: "لیست سفارش‌ها",
                path: `${adminRoot}/order-management/seller/orders`,
                inMenu: true,
                inSuperAdminMenu: false,
                permission: "viewSellerOrdersList",
                element: <SellerOrders />,
            },
            {
                icon: <PiRocketLaunch />,
                label: "سفارش‌های فوری",
                path: `${adminRoot}/order-management/instant`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <InstantOrders />,
            },
            {
                icon: <PiMotorcycle />,
                label: "سفارش‌های تهران",
                path: `${adminRoot}/order-management/tehran`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <TehranOrders />,
            },
            {
                icon: <PiAirplaneTakeoffLight />,
                label: "سفارش‌های شهرستان",
                path: `${adminRoot}/order-management/non-tehran`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <NonTehranOrders />,
            },
            {
                icon: <PiBasket />,
                label: "ایجاد سفارش جدید",
                path: `${adminRoot}/order-management/add-order`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <AddOrder />,
            },
        ],
    },
    {
        icon: <LuPackageOpen size={30} />,
        label: "مدیریت فروشگاه",
        path: `${adminRoot}/shop-management`,
        inMenu: true,
        element: <ProtectedView />,
        permission: "viewShopMenu",
        subs: [
            {
                icon: <CiBoxList />,
                label: "کوپن‌ها",
                path: `${adminRoot}/shop-management/copouns`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <Copouns />,
            },
            {
                icon: <CiBoxList />,
                label: "گزارشات",
                path: `${adminRoot}/shop-management/reports`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <FinancialReport />,
            },
            {
                icon: <CiBoxList />,
                label: "پیکربندی",
                path: `${adminRoot}/shop-management/settings`,
                inMenu: true,
                permission: "viewOrdersList",
                element: <ShopSettings />,
            },
        ],
    },
    {
        icon: <GrMoney size={30} />,
        label: "مدیریت سپیدار",
        path: `${adminRoot}/financial-management`,
        inMenu: true,
        element: <ProtectedView />,
        permission: "viewSalesMenu",
        subs: [
            {
                icon: <CiBoxList />,
                label: "لیست فروش‌ها (مالی)",
                path: `${adminRoot}/financial-management/sales`,
                inMenu: true,
                permission: "financialViewSalesList",
                element: <FinancialSales />,
            },
            {
                icon: <CiBoxList />,
                label: "لیست فاکتورهای فروش",
                path: `${adminRoot}/financial-management/invoices`,
                inMenu: true,
                permission: "viewSalesInvoice",
                element: <Invoices />,
            },
            {
                icon: <TbFaceIdError />,
                label: "فاکتورهای خطادار",
                path: `${adminRoot}/financial-management/queue-invoices`,
                inMenu: true,
                permission: "viewFailedInvoice",
                element: <QueueInvoices />,
            },
        ],
    },
    {
        icon: <HiOutlineInboxStack size={30} />,
        label: "مدیریت محصولات",
        path: `${adminRoot}/product-management`,
        inMenu: true,
        element: <ProtectedView />,
        permission: "viewProductsMenu",
        subs: [
            {
                icon: <CiBoxList />,
                label: "همه محصولات",
                path: `${adminRoot}/product-management/products`,
                inMenu: true,
                permission: "viewProductsList",
                element: <Products />,
            },
            {
                icon: <CiBoxList />,
                label: "افزودن محصول جدید",
                path: `${adminRoot}/product-management/add-new`,
                inMenu: true,
                permission: "viewProductsList",
                element: <AddNewProduct />,
            },
            {
                icon: <CiBoxList />,
                label: "برندها",
                path: `${adminRoot}/product-management/brands`,
                inMenu: true,
                permission: "viewProductsList",
                element: <Brands />,
            },
            {
                icon: <CiBoxList />,
                label: "دسته‌بندی‌ها",
                path: `${adminRoot}/product-management/categories`,
                inMenu: true,
                permission: "viewProductsList",
                element: <Categories />,
            },
            {
                icon: <CiBoxList />,
                label: "برچسب‌ها",
                path: `${adminRoot}/product-management/tags`,
                inMenu: true,
                permission: "viewProductsList",
                element: <Tags />,
            },
            {
                icon: <CiBoxList />,
                label: "ویژگی‌ها",
                path: `${adminRoot}/product-management/attributes`,
                inMenu: true,
                permission: "viewProductsList",
                element: <Attributes />,
            },
            {
                icon: <CiBoxList />,
                label: "دیدگاه‌ها",
                path: `${adminRoot}/product-management/reviews`,
                inMenu: true,
                permission: "viewProductsList",
                element: <Reviews />,
            },
            {
                icon: <CiBoxList />,
                label: "لیست محصولات",
                path: `${adminRoot}/product-management/seller/products`,
                inMenu: true,
                inSuperAdminMenu: false,
                permission: "viewSellerProductsList",
                element: <SellerProducts />,
            },
            {
                icon: <PiMicrosoftExcelLogo />,
                label: "ویرایش با اکسل",
                path: `${adminRoot}/product-management/update-excel`,
                inMenu: true,
                permission: "viewUpdateByExcel",
                element: <UpdateExcel />,
            },
        ],
    },
    {
        icon: <PiWarehouse size={30} />,
        label: "مدیریت فروشندگان",
        path: `${adminRoot}/warehouse-management`,
        inMenu: true,
        element: <ProtectedView />,
        permission: "viewWarehouseMenu",
        subs: [
            {
                icon: <TbBrandCitymapper />,
                label: "تطابق سایت و سپیدار",
                path: `${adminRoot}/warehouse-management/sepidar-sync`,
                inMenu: true,
                permission: "viewSepidarSync",
                element: <SepidarSync />,
            },
            {
                icon: <LuPackageSearch />,
                label: "مدیریت محموله‌ها",
                path: `${adminRoot}/warehouse-management/seller-inbound`,
                inMenu: true,
                inSuperAdminMenu: false,
                permission: "viewInbounds",
                element: <SellerInbound />,
            },
            {
                icon: <LuPackageMinus />,
                label: "مدیریت مرجوعی‌ها",
                path: `${adminRoot}/warehouse-management/seller-refund`,
                inMenu: true,
                inSuperAdminMenu: false,
                permission: "viewInbounds",
                element: <SellerRefund />,
            },
            {
                icon: <LuPackageSearch />,
                label: "لیست محموله‌ها فروشندگان",
                path: `${adminRoot}/warehouse-management/inbounds`,
                inMenu: true,
                permission: "viewSellersInbounds",
                element: <Inbounds />,
            },
            {
                icon: <TbTruckReturn />,
                label: "مدیریت مرجوعی‌ها",
                path: `${adminRoot}/warehouse-management`,
                permission: "viewSellersInbounds",
                inMenu: true,
                element: <Outlet />,
                subs: [
                    {
                        icon: <LuPackageMinus />,
                        label: "لیست مرجوعی فروشندگان",
                        path: `${adminRoot}/warehouse-management/refunds`,
                        inMenu: true,
                        permission: "viewSellersInbounds",
                        element: <Refunds />,
                    },
                    {
                        icon: <HiOutlineReceiptRefund />,
                        label: "ثبت مرجوعی",
                        path: `${adminRoot}/warehouse-management/submit-refund`,
                        inMenu: true,
                        permission: "viewSellersInbounds",
                        element: <SubmitRefund />,
                    },
                ],
            },
        ],
    },
    {
        icon: <PiPresentationChart size={30} />,
        label: "مدیریت فروش",
        path: `${adminRoot}/marketing-management`,
        inMenu: true,
        element: <ProtectedView />,
        permission: "viewMarketingMenu",
        subs: [
            {
                icon: <CiBoxList />,
                label: "لیست محصولات (آمار فروش)",
                path: `${adminRoot}/marketing-management/product-statistics`,
                inMenu: true,
                permission: "productsStatistics",
                element: <ProductStatistics />,
            },
            {
                icon: <CiBoxList />,
                label: "لیست فروش‌ها",
                path: `${adminRoot}/marketing-management/sales`,
                inMenu: true,
                permission: "marketingViewSalesList",
                element: <CommercialSales />,
            },
            {
                icon: <CiBoxList />,
                label: "لیست فروش‌ها",
                path: `${adminRoot}/marketing-management/seller/sales`,
                inMenu: true,
                inSuperAdminMenu: false,
                permission: "viewSellerSalesList",
                element: <SellerSales />,
            },
            {
                icon: <CiBoxList />,
                label: "آمار کدهای تخفیف",
                path: `${adminRoot}/marketing-management/voucher-statistics`,
                inMenu: true,
                permission: "marketingVouchersList",
                element: <VoucherStatistics />,
            },
            {
                icon: <CiBoxList />,
                label: "آمار سرعت فروش محصولات",
                path: `${adminRoot}/marketing-management/sales-velocity-statistics`,
                inMenu: true,
                permission: "marketingSalesVelocityList",
                element: <SalesVelocityStatistics />,
            },
            {
                icon: <CiBoxList />,
                label: "آمار خریداران",
                path: `${adminRoot}/marketing-management/returning-customer`,
                inMenu: true,
                permission: "viewReturningCustomers",
                element: <ReturningCustomer />,
            },
        ],
    },
    {
        icon: <VscSettings size={30} />,
        label: "تنظیمات",
        path: `${adminRoot}/setting`,
        permission: "viewSettingsMenu",
        element: <ProtectedView />,
        inMenu: true,
        subs: [
            {
                icon: <LiaUserLockSolid />,
                label: "مدیریت دسترسی",
                path: `${adminRoot}/setting/user-management`,
                permission: "viewUsersMenu",
                inMenu: true,
                element: <Outlet />,
                subs: [
                    {
                        icon: <BsStoplights />,
                        label: "مدیریت IPها",
                        path: `${adminRoot}/setting/user-management/white-list`,
                        inMenu: true,
                        element: <Limitation />,
                        permission: "editUserPermission",
                    },
                    {
                        icon: <PiUserSwitch />,
                        label: "مدیریت نقش‌ها",
                        path: `${adminRoot}/setting/user-management/permision`,
                        inMenu: true,
                        element: <Roles />,
                        permission: "editUserPermission",
                    },
                    {
                        icon: <FiUsers />,
                        label: "کاربران سیستم",
                        inMenu: true,
                        element: <Outlet />,
                        path: `${adminRoot}/setting/user-management/user`,
                        permission: "viewUserList",
                        subs: [
                            {
                                icon: <PiCubeDuotone />,
                                label: "کاربران سیستم",
                                inMenu: false,
                                element: <Users />,
                                path: `${adminRoot}/setting/user-management/user`,
                                permission: "viewUserList",
                            },
                            {
                                icon: <PiCubeDuotone />,
                                label: "افزودن کاربر جدید",
                                inMenu: false,
                                element: <AddUser />,
                                path: `${adminRoot}/setting/user-management/user/add`,
                                permission: "createNewUser",
                            },
                            {
                                icon: <PiCubeDuotone />,
                                label: "ویرایش کاربر",
                                inMenu: false,
                                element: <EditUser />,
                                path: `${adminRoot}/setting/user-management/user/edit`,
                                permission: "editUser",
                            },
                        ],
                    },
                ],
            },
            {
                icon: <AiOutlineFileSearch />,
                label: "لاگ سیستم",
                path: `${adminRoot}/setting/logs`,
                inMenu: true,
                permission: "viewSystemLogs",
                element: <Logs />,
            },
            {
                icon: <VscKey />,
                label: "تغییر رمز عبور",
                path: `${adminRoot}/setting/change-password`,
                inMenu: true,
                permission: "changePassword",
                element: <ChangePassword />,
            },
        ],
    },
    {
        path: "/user/",
        element: <Outlet />,
        subs: [
            {
                path: "login/",
                element: <Login />,
            },
            {
                path: "register/",
                element: <Login />,
            },
            {
                path: "denied/",
                element: <Denied />,
            },
        ],
    },
];
export default menuArray;
